// VEPC Gestao - Central Administrativa: Tela de Suporte e Erros
import { api } from '../api.js';

export async function renderSuporte() {
  const container = document.createElement('div');
  container.className = 'view-content';

  container.innerHTML = `
    <div class="view-header">
      <div class="view-title-group">
        <h2>Suporte Técnico & Relatórios de Erro</h2>
        <p>Gerenciamento de solicitações de atendimento das empresas e monitoramento de falhas do ecossistema.</p>
      </div>
    </div>

    <!-- Navegação de Abas -->
    <div style="display: flex; gap: 8px; border-bottom: 1px solid var(--vepc-border); margin-bottom: 20px;">
      <button class="btn btn-primary btn-sm" id="tab-chamados" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;">
        Chamados de Atendimento
      </button>
      <button class="btn btn-secondary btn-sm" id="tab-erros" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;">
        Registros de Erros Reportados
      </button>
    </div>

    <!-- Painel de Chamados -->
    <div id="secao-chamados">
      <div class="card-panel">
        <div class="table-responsive">
          <table class="data-table">
            <thead>
              <tr>
                <th>Empresa</th>
                <th>Título do Chamado</th>
                <th>Categoria</th>
                <th>Prioridade</th>
                <th>Status</th>
                <th>Solicitante</th>
                <th>Última Atualização</th>
                <th style="text-align: right;">Ação</th>
              </tr>
            </thead>
            <tbody id="corpo-chamados">
              <tr><td colspan="8" style="text-align: center; padding: 30px;">Carregando chamados...</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Painel de Erros -->
    <div id="secao-erros" style="display: none;">
      <div class="card-panel">
        <div class="table-responsive">
          <table class="data-table">
            <thead>
              <tr>
                <th>Origem</th>
                <th>Código do Erro</th>
                <th>Mensagem</th>
                <th>Empresa</th>
                <th>Versão App</th>
                <th>Ocorrências</th>
                <th>Status</th>
                <th style="text-align: right;">Ação</th>
              </tr>
            </thead>
            <tbody id="corpo-erros">
              <tr><td colspan="8" style="text-align: center; padding: 30px;">Carregando erros...</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div id="modal-container-suporte"></div>
  `;

  const secaoChamados = container.querySelector('#secao-chamados');
  const secaoErros = container.querySelector('#secao-erros');
  const tabChamados = container.querySelector('#tab-chamados');
  const tabErros = container.querySelector('#tab-erros');
  const corpoChamados = container.querySelector('#corpo-chamados');
  const corpoErros = container.querySelector('#corpo-erros');
  const modalContainer = container.querySelector('#modal-container-suporte');

  tabChamados.onclick = () => {
    tabChamados.className = 'btn btn-primary btn-sm';
    tabErros.className = 'btn btn-secondary btn-sm';
    secaoChamados.style.display = 'block';
    secaoErros.style.display = 'none';
  };

  tabErros.onclick = () => {
    tabChamados.className = 'btn btn-secondary btn-sm';
    tabErros.className = 'btn btn-primary btn-sm';
    secaoChamados.style.display = 'none';
    secaoErros.style.display = 'block';
    carregarErros();
  };

  async function carregarChamados() {
    try {
      const data = await api.getChamados();
      const chamados = data.chamados || [];

      if (chamados.length === 0) {
        corpoChamados.innerHTML = `<tr><td colspan="8" style="text-align: center; padding: 40px; color: var(--vepc-text-muted);">Nenhum chamado aberto.</td></tr>`;
        return;
      }

      corpoChamados.innerHTML = chamados.map(c => `
        <tr>
          <td><strong>${c.empresa_nome}</strong></td>
          <td>
            <div style="font-weight: 700; color: var(--vepc-azul-institucional); font-size: 13.5px;">${c.titulo}</div>
            <div style="font-size: 11px; color: var(--vepc-text-muted);">${c.total_mensagens || 0} mensagem(ns)</div>
          </td>
          <td><span class="badge badge-avaliacao">${c.categoria.toUpperCase()}</span></td>
          <td>
            <span class="badge ${c.prioridade === 'alta' ? 'badge-vencida' : 'badge-aberto'}">
              ${c.prioridade.toUpperCase()}
            </span>
          </td>
          <td><span class="badge badge-${c.status}">${c.status.replace('_', ' ').toUpperCase()}</span></td>
          <td>${c.solicitante_nome}</td>
          <td style="font-family: var(--font-mono); font-size: 12px; color: var(--vepc-text-muted);">${c.atualizado_em.slice(0, 16)}</td>
          <td style="text-align: right;">
            <button class="btn btn-secondary btn-sm btn-atender-chamado" data-id="${c.id}">
              Atender
            </button>
          </td>
        </tr>
      `).join('');

      corpoChamados.querySelectorAll('.btn-atender-chamado').forEach(b => {
        b.onclick = () => abrirModalAtendimento(b.dataset.id);
      });
    } catch (err) {
      corpoChamados.innerHTML = `<tr><td colspan="8" style="color: var(--vepc-danger); padding: 20px;">Erro: ${err.message}</td></tr>`;
    }
  }

  async function abrirModalAtendimento(chamadoId) {
    try {
      const data = await api.getChamado(chamadoId);
      const c = data.chamado;
      const msgs = data.mensagens || [];

      modalContainer.innerHTML = `
        <div class="modal-backdrop">
          <div class="modal-card" style="max-width: 700px;">
            <div class="modal-header">
              <div>
                <h3 style="font-size: 16px; font-weight: 800; color: var(--vepc-azul-institucional);">${c.titulo}</h3>
                <div style="font-size: 12px; color: var(--vepc-text-muted);">${c.empresa_nome} &bull; ${c.solicitante_nome}</div>
              </div>
              <button class="btn btn-secondary btn-sm btn-fechar-modal">&times;</button>
            </div>
            <div class="modal-body" style="padding: 20px;">
              <div style="background: #FAFCFE; border: 1px solid var(--vepc-border); border-radius: var(--radius-md); padding: 12px; margin-bottom: 16px; font-size: 12.5px; display: flex; gap: 16px;">
                <div><strong>Categoria:</strong> ${c.categoria}</div>
                <div><strong>Prioridade:</strong> ${c.prioridade}</div>
                <div><strong>Status Atual:</strong> ${c.status}</div>
              </div>

              <!-- Mensagens -->
              <div style="display: flex; flex-direction: column; gap: 10px; margin-bottom: 20px; max-height: 280px; overflow-y: auto; padding: 4px;">
                ${msgs.map(m => `
                  <div style="padding: 10px 14px; border-radius: var(--radius-md); font-size: 13px; ${m.autor_tipo === 'vepc' ? (m.interna ? 'background: #FEF3C7; border: 1px solid #FDE68A;' : 'background: #EFF6FF; border: 1px solid #BFDBFE; align-self: flex-end; max-width: 85%;') : 'background: white; border: 1px solid var(--vepc-border); align-self: flex-start; max-width: 85%;'}">
                    <div style="display: flex; justify-content: space-between; gap: 10px; font-size: 11px; margin-bottom: 4px;">
                      <strong>${m.autor_nome} ${m.interna ? '🔒 (Nota Interna)' : ''}</strong>
                      <span style="font-family: var(--font-mono); color: var(--vepc-text-muted);">${m.criado_em.slice(0, 16)}</span>
                    </div>
                    <div>${m.texto}</div>
                  </div>
                `).join('')}
              </div>

              <!-- Responder -->
              <form id="form-responder">
                <div class="form-group">
                  <label class="form-label">Resposta ou Acompanhamento:</label>
                  <textarea id="resp-texto" class="form-control" rows="3" placeholder="Digite a resposta para o cliente ou anotação interna..." required></textarea>
                </div>

                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <label class="module-switch">
                    <input type="checkbox" id="resp-interna" style="width: 16px; height: 16px;" />
                    <span>Nota Interna (Visível apenas para operadores VEPC)</span>
                  </label>
                  <button type="submit" class="btn btn-primary btn-sm">Enviar Resposta</button>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary btn-sm btn-fechar-modal">Fechar</button>
            </div>
          </div>
        </div>
      `;

      modalContainer.querySelectorAll('.btn-fechar-modal').forEach(b => {
        b.onclick = () => { modalContainer.innerHTML = ''; };
      });

      const form = modalContainer.querySelector('#form-responder');
      form.onsubmit = async (e) => {
        e.preventDefault();
        try {
          await api.responderChamado(chamadoId, {
            texto: modalContainer.querySelector('#resp-texto').value,
            interna: modalContainer.querySelector('#resp-interna').checked
          });
          abrirModalAtendimento(chamadoId);
          carregarChamados();
        } catch (err) {
          alert('Erro ao responder: ' + err.message);
        }
      };

    } catch (err) {
      alert('Erro: ' + err.message);
    }
  }

  async function carregarErros() {
    try {
      const data = await api.getErros();
      const erros = data.erros || [];

      if (erros.length === 0) {
        corpoErros.innerHTML = `<tr><td colspan="8" style="text-align: center; padding: 40px; color: var(--vepc-text-muted);">Nenhum erro registrado.</td></tr>`;
        return;
      }

      corpoErros.innerHTML = erros.map(er => `
        <tr>
          <td><span class="badge badge-avaliacao">${er.origem.toUpperCase()}</span></td>
          <td><code style="font-family: var(--font-mono); font-weight: 700; color: var(--vepc-danger);">${er.codigo}</code></td>
          <td style="max-width: 320px; font-size: 12.5px;">${er.mensagem}</td>
          <td>${er.empresa_nome || 'Geral / Sistema'}</td>
          <td>${er.versao_app || '—'}</td>
          <td><strong>${er.ocorrencias}</strong></td>
          <td>
            <span class="badge ${er.resolvido ? 'badge-sucesso' : 'badge-vencida'}">
              ${er.resolvido ? 'RESOLVIDO' : 'PENDENTE'}
            </span>
          </td>
          <td style="text-align: right;">
            ${!er.resolvido ? `
              <button class="btn btn-secondary btn-sm btn-resolver-erro" data-id="${er.id}">
                Resolver
              </button>
            ` : '—'}
          </td>
        </tr>
      `).join('');

      corpoErros.querySelectorAll('.btn-resolver-erro').forEach(b => {
        b.onclick = async () => {
          try {
            await api.resolverErro(b.dataset.id);
            carregarErros();
          } catch (e) {
            alert('Erro: ' + e.message);
          }
        };
      });
    } catch (err) {
      corpoErros.innerHTML = `<tr><td colspan="8" style="color: var(--vepc-danger); padding: 20px;">Erro: ${err.message}</td></tr>`;
    }
  }

  carregarChamados();
  return container;
}
